import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Container, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { useStore } from "../../../../contexts/store-provider";
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";

const StoreSelectionView: React.FC = () => {
  const { storeCmsStore } = useStore();
  const {
    GetStoreManagementListService,
    inProgress,
    allCMSStoreList,
    resetGetCMSStoreListState,
    resetCMSStoreListFilter,
    cmsStoreListFilter,
  } = storeCmsStore;

  const history = useHistory();

  useEffect(() => {
    // fetch all stores once with a big page size
    GetStoreManagementListService(1, 1000, {
      ...cmsStoreListFilter,
      BusinessTypeId: [],
      StoreName: "",
      PrefectureName: "",
    });

    return () => {
      resetGetCMSStoreListState();
      resetCMSStoreListFilter();
    };
  }, [
    GetStoreManagementListService,
    resetGetCMSStoreListState,
    resetCMSStoreListFilter,
    cmsStoreListFilter,
  ]);

  const handleStoreChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const storeCode = e.target.value;
    if (storeCode) {
      history.push(`/Store/${storeCode}`);
    }
  };

  return (
    <Container className="pt-4">
      {inProgress && <FormLoader loading={inProgress} />}
      <h4>
        <FormattedMessage id="please_select_store" />
      </h4>
      <Form.Select onChange={handleStoreChange} defaultValue="">
        <option value="">
          <FormattedMessage id="select_store" />
        </option>
        {allCMSStoreList?.map((store) => (
          store.ShowOnReservationSite && (
          <option key={store.Id} value={store.StoreCode}>
            {store.StoreName}
          </option>
        )))}
      </Form.Select>
    </Container>
  );
};

export default observer(StoreSelectionView);
